export const PXCirclestat = (function() {
	'use strict';

	function init() {
		events();
	}

	function events() {

		$('#stats-slider').slick({
			autoplay: true,
			autoplaySpeed: 2000,
			slidesToShow: 1,
			centerMode: true,
			variableWidth: true,
			mobileFirst: true, 
			responsive: [
			   {
				  breakpoint: 480,
				  settings: "unslick"
			   }
			],
		});
	}

	return {
		init: init
	};
})();
